import React from "react";

import { ICellRendererParams } from "@ag-grid-community/core";
import { faCommentAltLines } from "@fortawesome/pro-light-svg-icons/faCommentAltLines";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Divider from "antd/es/divider";
import Popover from "antd/es/popover";
import { useIntl } from "react-intl";

import NoteType from "@mapmycustomers/shared/types/entity/common/Note";

import Note from "./components/Note";
import styles from "./NotesCellRenderer.module.scss";

const NotesCellRenderer: React.FC<ICellRendererParams> = ({ value }) => {
  const intl = useIntl();

  if (!value || !value.length) {
    // Wrapping into fragment because this component can't return a plain string.
    // On the other hand it can't return `null` because that's an AgGrid recommendation
    // to return empty strings: https://www.ag-grid.com/react-hooks/#react-null
    return <>{""}</>;
  }

  return (
    <div className={styles.container}>
      <Popover
        className={styles.cell}
        content={
          <div className={styles.noteList}>
            {(value as NoteType[]).map((note, index, notes) => (
              <React.Fragment key={note.id}>
                <Note note={note} />
                {index < notes.length - 1 ? <Divider /> : null}
              </React.Fragment>
            ))}
          </div>
        }
      >
        <FontAwesomeIcon icon={faCommentAltLines} />
        &nbsp;
        {intl.formatMessage({
          id: "grid.notesCell.description",
          defaultMessage: "Notes",
          description: "Description text in the notes cell",
        })}
      </Popover>
    </div>
  );
};

export default NotesCellRenderer;
